export default __webpack_public_path__ + "static/media/banner1.526d37f4.jpg";